import React from "react";
import { Quote } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export const IdeanSynty = () => {
  const { t } = useLanguage();
  return (
    <section id="idean-synty" data-testid="idean-synty-section" className="relative py-24 md:py-32 border-t-2 border-[#1a1a1a] grain overflow-hidden">
      <div className="absolute top-8 left-5 md:left-10 font-mono text-[10px] tracking-[0.3em] text-[#A3A3A3] uppercase">{t("idea.section_number")}</div>
      <div className="absolute top-8 right-5 md:right-10 font-mono text-[10px] tracking-[0.3em] text-[#FFEA00] uppercase">{t("idea.right_tag")}</div>

      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="font-mono text-[11px] tracking-[0.3em] text-[#FFEA00] uppercase mb-4">{t("idea.eyebrow")}</div>
            <h2 data-testid="idean-synty-heading" className="font-display font-bold text-white text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.95] tracking-tight">
              {t("idea.heading_line1")}
              <br />
              {t("idea.heading_line2_prefix")}<span className="text-[#FFEA00]">{t("idea.heading_accent")}</span>.
            </h2>
            <div className="mt-8 w-32 h-2 hazard-stripes-anim" />
            <div className="mt-10 border-2 border-[#1f1f1f] bg-black/40 p-5 max-w-sm">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 hazard-stripes-vertical" />
                <div className="leading-tight">
                  <div className="font-display font-bold text-white text-base uppercase tracking-wider">{t("idea.signature_team")}</div>
                  <div className="font-mono text-[10px] tracking-[0.25em] text-[#FFEA00] uppercase mt-1">{t("idea.signature_location")}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative border-2 border-[#FFEA00]/40 bg-[#0a0a0a] p-8 md:p-12">
              <Quote aria-hidden="true" className="absolute -top-5 -left-5 w-14 h-14 text-[#FFEA00] fill-[#FFEA00] bg-[#0a0a0a] p-2 border-2 border-[#FFEA00]" strokeWidth={0} />
              <div className="absolute -top-px -right-px w-3 h-3 bg-[#FFEA00]" />
              <div className="absolute -bottom-px -left-px w-3 h-3 bg-[#FFEA00]" />
              <p data-testid="idean-synty-paragraph" className="font-sans text-[#D4D4D4] text-base md:text-lg leading-relaxed">
                {t("idea.paragraph")}
              </p>
              <div className="mt-8 h-1.5 hazard-stripes-anim" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
